import type { PageMeta } from '../../../lib/permissions/pageMeta'
import PurchasesPage from '../../purchases/PurchasesPage'

export const pageMeta: PageMeta = {
  key: 'buy.purchases',
  label: 'Purchases',
  module: 'Trading',
  section: 'Buy',
  description: 'List & manage purchase orders',
  defaultPermissions: {
    owner: 'edit', admin: 'edit', manager: 'edit',
    accountant: 'view', cashier: 'none', viewer: 'view',
  },
  hasVisibility: true,
  ownerColumn: 'created_by',
}

export default function BuyPurchasesTab() {
  return <PurchasesPage />
}
